import { observable, action} from 'mobx';
import settings from '../cultureSettings.json'

export default class Transport{
    @observable amount;
    @observable groupQuantity;
    @observable transportStatus;
    @observable active;

    constructor(culture, capacity, amount =0 , moistureLevel = 0, wasteLevel = 0, groupQuantity = 0, status = 'alert'){
        this.totalCapacity = capacity;
        this.culture = culture;
        this.amount = amount;
        this.moistureLevel = moistureLevel;
        this.wasteLevel = wasteLevel;
        this.groupQuantity = groupQuantity;
        this.transportStatus = status;
        this.active = false;
    }

    @action setAmount(amount){
        this.amount = amount;
    }

    @action setGroupQuantity(quantity){
        this.groupQuantity = quantity;
    }

    @action setStatus(status){
        this.status = status;
    }

    @action setActive(active){
        this.active = active;
    }

    @action filling(delta){
        this.amount += delta;
    }

    @action shipping(delta, type){
        if(delta >= this.amount) {
            this.groupQuantity -= 1;
            this.amount = (type === 'truck' ? 20 : 60)*settings[this.culture].volume;
        }else {
            this.amount -= delta;
        }
    }
}



// WEBPACK FOOTER //
// ./src/shared/stores/objects/transport.js